import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/vip/db.png'
import _imports_1 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = {
  key: 0,
  class: "historyContainer"
}
const _hoisted_3 = { class: "tabelContainer" }
const _hoisted_4 = { class: "tabelTitle" }
const _hoisted_5 = {
  key: 2,
  class: "no_more"
}

import { ref, PropType, computed } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import CustomHeader from '@/themes/themeTwo/components/common/customHeader.vue';
import NoData from '@/themes/themeTwo/components/common/noData.vue';
import { getVIPRewardHistory } from '@/api/activity';
import { getVIPHistoryDataFunc } from '@/view/vip/supportScript'
const PAGE_SIZE = 20

export default /*@__PURE__*/_defineComponent({
  __name: 'vipHistoryPopup',
  props: {
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
},
  emits: ['updateHistoryList'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const total = ref(0)
const historyList = ref<any[]>([])
const emits = __emit
const open = (data: any) => {
    show.value = true
    getVIPHistoryData()
}

const close = () => {
    show.value = false
    historyList.value = []
    total.value = 0
    pageNum.value = 1
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const getVIPHistoryData = () => {
    getVIPHistoryDataFunc(getVIPRewardHistory, loadingRef, pageNum, pageSize, total, historyList, showError)
}
const getNextPageRewardData = () => {
    if (total.value > pageNum.value * pageSize.value) {
        pageNum.value = pageNum.value + 1
        loadingRef.value.open()
        getVIPHistoryData()
    }
}
__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "right",
      style: {
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CustomHeader, {
            text: _ctx.$t('activity.bonuRegistation'),
            isPopupCloseBackIcon: true,
            onClosePopup: close
          }, null, 8, ["text"]),
          (!__props.isUseFirstRecharge)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[1] || (_cache[1] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('vip.registerCollection')), 1)
                  ]),
                  _createVNode(_component_van_row, {
                    class: "tabelHead",
                    justify: "space-between"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "10",
                        class: "headCol"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('vip.collectionTime')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "7",
                        class: "headCol"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('vip.event')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "6",
                        class: "headCol"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('vip.money')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_row, {
                      class: "tabeldata",
                      key: index,
                      justify: "space-between"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "10",
                          class: "headCol"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.updateTime), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_van_col, {
                          span: "7",
                          class: "headCol"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.rewardType == 1 ? _ctx.$t('vip.upgrade') : item.rewardType
                            == 2 ? _ctx.$t('vip.weekly') : item.rewardType == 3 ? _ctx.$t('vip.monthly') : item.rewardType == 4 ?
                                _ctx.$t('vip.daily') : ''), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_van_col, {
                          span: "6",
                          class: "headCol"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.coin), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                (historyList.value?.length <= 0)
                  ? (_openBlock(), _createBlock(NoData, { key: 0 }))
                  : _createCommentVNode("", true),
                (total.value > pageNum.value * pageSize.value)
                  ? (_openBlock(), _createBlock(_component_van_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "24",
                          class: "arrowDown"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "",
                              onClick: getNextPageRewardData
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('message.noMore')), 1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})